module.exports = __webpack_public_path__ + "img/course-1-5.0d8f8b9d.jpeg";